const BreakpointsEnum = Object.freeze({
    largeDesktop: "large-desktop",
    desktop: "desktop",
    tablet: "tablet",
    mobile: "mobile"
});

export default BreakpointsEnum;